export const GET_TUTORIAL_DATA = "GET_TUTORIAL_DATA";
export const GET_TUTORIAL_DATA_SUCCESS = "GET_TUTORIAL_DATA_SUCCESS";

export const GET_TUTORIAL_DATA_BY_ID = "GET_TUTORIAL_DATA_BY_ID";
export const GET_TUTORIAL_DATA_BY_ID_SUCCESS = "GET_TUTORIAL_DATA_BY_ID_SUCCESS";